import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';

const Datas = [
    {
        id: 1,
        title: "Exceed clients’ and colleagues’ expectations",
        para: "We strive to exceed the expectations of our clients and colleagues by delivering exceptional results. Through innovation, dedication, and teamwork, we consistently go beyond what's required."
    },
    {
        id: 2,
        title: "Take ownership and question the status quo in a constructive manner",
        para: "We take ownership of our work and challenge the status quo with a constructive approach. By fostering innovation and accountability, we drive continuous improvement and meaningful change."
    },
    {
        id: 3,
        title: "Be brave, curious and experiment – learn from all successes and failures",
        para: "We embrace bravery and curiosity, encouraging experimentation to uncover new possibilities. Every success and failure is a valuable lesson that drives growth and innovation."
    },
    {
        id: 4,
        title: "Act in a way that makes all of us proud",
        para: "We are committed to acting with integrity and excellence in everything we do, ensuring that our actions reflect the values we stand for. By working together, we create outcomes that make us all proud of our contributions and achievements."
    },
    {
        id: 5,
        title: "Build an inclusive, transparent and socially responsible culture",
        para: "We are dedicated to fostering an inclusive, transparent, and socially responsible culture where every voice is valued and heard. By prioritizing openness and accountability, we create an environment that empowers individuals and positively impacts the community."
    }
]




const AboutThree = () => {
    return (
        <div className="section section-padding bg-color-dark pb--80 pb_lg--40 pb_md--20">
            <div className="container">
                <SectionTitle 
                    subtitle="Our Valus"
                    title="Why should you work with us?"
                    description=""
                    textAlignment="heading-left heading-light-left mb--100"
                    textColor=""
                />

                <div className="row">
                    {Datas.map((data) => (
                        <div className="col-lg-4" key={data.id}>
                            <div className="about-quality">
                                <h3 className="sl-number">{data.id}</h3>
                                <h5 className="title">{data.title}</h5>
                                <p>{data.para}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-1.png"} alt="Circle" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/line-3.png"} alt="Circle" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"} alt="Circle" /></li>
            </ul>
        </div>
    )
}

export default AboutThree;